import {useMutation, UseMutationResult} from '@tanstack/react-query';

import {fetchChatwootSsoLink} from './chatwoot-api';
import {OmnichannelSsoLinkResponseType} from './chatwoot-type';

export function useChatwootSsoLink(): UseMutationResult<OmnichannelSsoLinkResponseType, void, void> {
    return useMutation<OmnichannelSsoLinkResponseType, void, void>({
        mutationFn: fetchChatwootSsoLink,
        mutationKey: ['chatwoot-sso'],
        cacheTime: 0,
        onSuccess: (data) => {
            if (data?.link) {
                window.open(data.link, '_blank', 'noopener,noreferrer');
            }
        },
        onError: (error) => {
            console.error('[Chatwoot SSO] Ошибка получения SSO-ссылки:', error);
        },
    });
}
